import type { DurationLike } from "luxon";
import { DateTime } from "luxon";

const isDateInFutureDuration = (
  date: Date | undefined,
  duration: DurationLike = { months: 3, weeks: 2 }
) => {
  if (!date) return false;
  const now = DateTime.now();
  const dateTime = DateTime.fromJSDate(date);
  return dateTime >= now && dateTime <= now.plus(duration);
};

export { isDateInFutureDuration };
